import api from '../BaseUrl';
import { Educations } from '../Client/PublicResponse';

export type { Educations };

export const getEducation = async (): Promise<Educations[]> => {
  const res = await api.get<Educations[]>('/api/Education/GetEducation');
  return res.data;
};

export const postEducation = async (data: Omit<Educations, 'id'>): Promise<void> => {
  await api.post('/api/Admin/AddEducation', data);
};

export const putEducation = async (id: string | number, data: Omit<Educations, 'id'>): Promise<void> => {
  await api.put(`/api/Admin/UpdateEducation/${id}`, data);
};

export const deleteEducation = async (id: string | number): Promise<void> => {
  await api.delete(`/api/Admin/DeleteEducation/${id}`);
};
